import { Component, inject } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { faCircleNotch, faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ToastrService } from 'ngx-toastr';
import { IconsService } from 'src/app/shared/services/icons.service';
import { Role } from 'src/app/models/role.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-roles',
  template: `
  <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Perfiles y roles</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-administration [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Roles y permisos</h2>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-fill ms-3 me-3">
          </div>
          <div>
          </div>
          <div class="text-end">
            <button class="btn btn-zazz-dark" routerLink="create" *ngIf="authService.hasPermission('can_create_roles')">
              <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
              Agregar Rol
            </button>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">Nombre</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Grupo</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr app-tr-role
                [role]="role"
                *ngFor="let role of roles"
                ></tr>
              </tbody>
            </table> 
          </div>
          <div class="list-group-item text-center py-5" *ngIf="roles.length==0&&loading">
            <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
            <p class="text-muted">Cargando...</p>
          </div>
          <div class="list-group-item text-center py-5" *ngIf="roles.length==0&&!loading">
            <img src="/assets/images/empty-state.png" width="240px">
            <h5 class="text-muted">No se encontraron registros</h5>
          </div>
          <div class="list-group-item text-center pt-3" *ngIf="roles.length>0">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"                  
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>

  `,
  styleUrls: []
})
export class RolesComponent {
  roles: Role[] = [];
  profile: any = {};

  loading: boolean = false;
  currentView: string = 'roles';
  p: number = 1;

  groups: any[] = [
    { id: 1, name: 'Administradores' },
    { id: 2, name: 'Técnicos' },
    { id: 3, name: 'Inquilinos' },
  ];
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private breadcrumbService: BreadcrumbService,
    private toastr: ToastrService,
    public icons: IconsService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
  }

  ngOnInit() {
    this.store.getRoles({}).subscribe({
      next: (data: any[]) => {
        this.roles = data;
      }, 
      error: (error: any) => {
        this.toastr.error('No se pudieron cargar los roles', 'Error');
      }
    });
    this.breadcrumbService.set('@roles', 'Roles');
  }

  pageChanged(event: any) {
  }
}
